/**
 * Overrides the canonical link and og:url set by canonical.global.ts.
 *
 * The global middleware derives the canonical from the raw request URL, so it
 * reflects whatever is in the address bar — including non-canonical slugs or
 * trailing periods. Call this composable whenever the page receives a canonical
 * path from the API (or derives one from normalised route params) that may
 * differ from the raw browser URL.
 *
 * The key/id values match those used by canonical.global.ts and Nuxt i18n, so
 * this call wins over the middleware-set values.
 *
 * @param path  Server-relative path (e.g. "/en/part/te-connectivity/ABC123").
 *              Pass null or undefined to leave the middleware canonical intact.
 */
export function useCanonicalUrl(path: string | null | undefined) {
    if (!path) return;
    const { public: config } = useRuntimeConfig();
    const href = `${config.baseUrl}${path}`;
    useHead({
        link: [{ id: "i18n-can", rel: "canonical", href }],
        meta: [{ id: "i18n-og-url", property: "og:url", content: href }],
    });
}
